import { useNavigate } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { VN_AGENT_SERVICES } from "../../data/content";
import { FadeUp, SectionHead, ChapterTag } from "./Reveal";

export default function VietnamSourcingSection() {
    const navigate = useNavigate();
    return (
        <section
            id="vietnam-sourcing"
            className="scroll-mt-20 bg-ivory py-24 text-navy-deep lg:py-32"
            data-testid="vietnam-sourcing-section"
        >
            <div className="mx-auto max-w-[1440px] px-5 lg:px-10">
                <ChapterTag light>Chapter 06 &mdash; Trading and Sourcing from Vietnam</ChapterTag>
                <div className="mt-8 grid grid-cols-1 items-center gap-14 lg:grid-cols-2 lg:gap-20">
                    <div>
                        <SectionHead
                            light
                            eyebrow="Local Agents in Vietnam"
                            title="Looking for Products from Vietnam?"
                            copy="Our agents in Vietnam support international buyers seeking reliable product and supplier connections. From the initial requirement to supplier communication, samples, documentation and shipment planning, we help make sourcing from Vietnam clearer and easier to manage."
                        />
                        <FadeUp delay={0.15}>
                            <button
                                type="button"
                                data-testid="vn-sourcing-cta"
                                onClick={() => navigate("/vietnam-sourcing-agent")}
                                className="group mt-9 inline-flex items-center gap-3 bg-navy-deep px-7 py-4 text-xs font-bold uppercase tracking-[0.18em] text-ivory transition-colors duration-300 hover:bg-gold hover:text-navy-deep"
                            >
                                Source Products from Vietnam
                                <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
                            </button>
                        </FadeUp>
                    </div>
                    <FadeUp delay={0.1}>
                        <span className="text-[11px] font-semibold uppercase tracking-[0.3em] text-gold">
                            What Our Vietnam Agents Can Support
                        </span>
                        <ul className="mt-6 grid grid-cols-1 gap-x-8 gap-y-3.5 sm:grid-cols-2">
                            {VN_AGENT_SERVICES.map((s) => (
                                <li key={s} className="flex items-start gap-2.5 text-sm text-navy-deep/75">
                                    <Check size={14} className="mt-0.5 shrink-0 text-gold" aria-hidden="true" />
                                    {s}
                                </li>
                            ))}
                        </ul>
                    </FadeUp>
                </div>
            </div>
        </section>
    );
}
